import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";

const CustomPageHeader = ({ title, badge, buttons = [], customActions = null, customSelect = null, className = "", titleIcon, lastUpdatedAt, showDivider = true }) => {
    const renderButton = (button, index) => {
        const { label, onClick, className: buttonClass = "", icon: Icon, iconSize = 16, iconWeight = "bold", disabled = false, loading = false, variant = "primary" } = button;

        const getButtonClass = () => {
            const baseClass = "button-large";
            const variantClasses = {
                primary: "blue-button",
                secondary: "gray-button",
                success: "green-button",
                danger: "red-button",
                cancel: "cancel-button",
            };
            return `${baseClass} ${variantClasses[variant] || variantClasses.primary} ${buttonClass}`;
        };

        return (
            <button key={index} onClick={onClick} className={getButtonClass()} disabled={disabled || loading}>
                {loading ? (
                    <CircularProgress size={14} />
                ) : (
                    Icon && <Icon size={iconSize} weight={iconWeight} />
                )}
                <span>{loading ? "Chargement..." : label}</span>
            </button>
        );
    };

    return (
        <div className={`c-page-header ${className}`}>
            <div className="c-page-header__title">
                {titleIcon &&
                    (titleIcon.svg ? (
                        <img
                            src={titleIcon.svg}
                            alt=""
                            style={{
                                width: titleIcon.size || 30,
                                height: titleIcon.size || 30,
                            }}
                        />
                    ) : (
                        <titleIcon.icon size={titleIcon.size || 30} weight={titleIcon.weight || "bold"} color={titleIcon.color || "var(--blue-icon)"} />
                    ))}
                <h1>{title}</h1>
                {badge && badge}
            </div>
            {(lastUpdatedAt || buttons.length > 0 || customActions || customSelect) && (
                <div className="c-page-header__actions">
                    {lastUpdatedAt && (
                        <>
                            <div className="last-updated__wrapper">
                                <span>Dernière MÀJ : {dayjs(lastUpdatedAt).format("DD/MM à HH:mm")}</span>
                            </div>
                            {showDivider && <div className="c-divider animate"></div>}
                        </>
                    )}
                    {customSelect && (
                        <>
                            {customSelect}
                            {(buttons.length > 0 || customActions) && <div className="c-divider sm"></div>}
                        </>
                    )}
                    {customActions ? customActions : buttons.map(renderButton)}
                </div>
            )}
        </div>
    );
};

export default CustomPageHeader;
